import { Box, makeStyles, Switch, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { BooleanTableFilter } from './types';
import { useFilterRegistration } from '../WbTable';

const useStyles = makeStyles<Theme, { value: boolean }>(
  theme => ({
    root: {
      height: '36px',
      borderRadius: '4px',
      padding: '6px 8px 6px 12px',
      border: `1px solid ${theme.palette.grey[400]}`,
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      cursor: 'pointer',
      background: props =>
        props.value
          ? theme.palette.grey[100]
          : theme.palette.background.default,
    },
  }),
  { name: 'BooleanFilter' },
);

export const BooleanFilter = ({
  value,
  style,
  className,
  startIcon,
  field,
  color,
  onChange,
  disabled,
}: BooleanTableFilter) => {
  const [innerValue, setInnerValue] = useState<boolean>(value ?? false);
  const classes = useStyles({ value: innerValue });

  // Register this filter's active state with the parent toolbar
  useFilterRegistration(value, field);

  useEffect(() => {
    setInnerValue(value ?? false);
  }, [value]);

  return (
    <Box
      style={style}
      className={clsx(classes.root, className)}
      onClick={() => {
        if (!disabled) {
          onChange(!innerValue);
        }
      }}
    >
      {startIcon && startIcon}
      <Typography style={{ color }} component="label" htmlFor={field}>
        {field}
      </Typography>

      <Switch
        id={field}
        color="primary"
        style={{ color }}
        checked={innerValue}
        name={field}
      />
    </Box>
  );
};
